<app-modal-container>
  <header header>
    <div class="flex w-full items-center justify-end p-4">
      <button (click)="close()" class="cursor-pointer flex items-center">
        <app-icon name="material-symbols:close" class="size-5! text-zinc-400" />
      </button>
    </div>
  </header>

  <div
    class="flex flex-col gap-3 w-full h-full items-center justify-center p-4"
  >
    <img src="/complete.svg" alt="제출 완료 아이콘" class="size-10" />

    <!-- 제목 -->
    <h3 class="text-lg font-semibold text-zinc-800 text-center">
      참가신청 완료
    </h3>

    <!-- 정보 -->
    <div class="w-full bg-zinc-50 rounded-xl p-3 flex flex-col gap-2">
      <div class="flex justify-between items-center">
        <span class="text-sm text-zinc-400 font-medium">참가행사</span>
        <span class="text-sm text-zinc-800 font-medium">{{
          eventTitle()
        }}</span>
      </div>
      <div class="flex justify-between items-center">
        <span class="text-sm text-zinc-400 font-medium">기업명</span>
        <span class="text-sm text-zinc-800 font-medium">{{
          companyName()
        }}</span>
      </div>
      <div class="flex justify-between items-center">
        <span class="text-sm text-zinc-400 font-medium">담당자명</span>
        <span class="text-sm text-zinc-800 font-medium">{{
          managerName()
        }}</span>
      </div>
      <div class="flex justify-between items-center">
        <span class="text-sm text-zinc-400 font-medium">연락처</span>
        <span class="text-sm text-zinc-800 font-medium">{{
          managerPhone()
        }}</span>
      </div>
    </div>

    <!-- 안내 메시지 -->
    <div class="text-center">
      <p class="text-sm text-zinc-500">참가신청이 완료되었습니다.</p>
      <p class="text-sm text-zinc-500">
        참가신청 정보는 알림톡으로 발송됩니다.
      </p>
    </div>
  </div>

  <footer class="w-full p-4">
    <button
      routerLink="/"
      (click)="close(true)"
      class="cursor-pointer w-full bg-orange-500 text-white font-medium py-2 px-3 rounded-xl"
    >
      홈으로
    </button>
  </footer>
</app-modal-container>
